import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off


export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.routes') },
            { path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes') },
            { path: 'all-notes', loadChildren: () => import('app/modules/notes/notes.routes') },
            { path: 'stakeholders', loadChildren: () => import('app/modules/admin/stakeholders/stakeholders.routes') },
            { path: 'banks', loadChildren: () => import('app/modules/admin/banks/banks.routes') },
            { path: 'warehouses', loadChildren: () => import('app/modules/admin/warehouses/warehouses.routes') },
            { path: 'users', loadChildren: () => import('app/modules/admin/users/users.routes') },
            { path: 'casl-permissions', loadChildren: () => import('app/modules/admin/casl-permissions/casl-permissions.routes') },
            { path: 'dropdown-options', loadChildren: () => import('app/modules/system-setup/dropdown-options/dropdown-options.routes') },
            { path: 'audit-logs', loadChildren: () => import('app/modules/audit/audit.routes') },
            { path: 'purchase-confirmations', loadChildren: () => import('app/modules/purchase-confirmations/purchase-confirmations.routes') },
            { path: 'offers', loadChildren: () => import('app/modules/offers/offers.routes') },
            { path: 'templates', loadChildren: () => import('app/modules/admin/templates/templates.routes') },
            { path: 'purchase-shipping-instructions', loadChildren: () => import('app/modules/purchase-shipping-instructions/purchase-shipping-instructions.routes') },
            { path: 'sales-confirmations', loadChildren: () => import('app/modules/sales-confirmations/sales-confirmations.routes') },
            { path: 'stock', loadChildren: () => import('app/modules/stock/stock.routes') },
            { path: 'leads', loadChildren: () => import('app/modules/leads/leads.routes') },
            { path: 'sales-shipping-instructions', loadChildren: () => import('app/modules/sales-shipping-instructions/sales-shipping-instructions.routes') },
            { path: 'sales-invoices', loadChildren: () => import('app/modules/sales-invoices/sales-invoices.routes') },
            { path: 'journals', loadChildren: () => import('app/modules/journals/journals.routes') },
        ]
    }
];